export default "__VITE_ASSET__3c0a7ac6__"